import React, { useEffect, useRef } from 'react';
import { CountUp } from 'countup.js';

const CountUpWrapper = ({ end, start = 0, duration = 2, className = '', suffix = '', prefix = '' }) => {
  const ref = useRef(null);

  useEffect(() => {
    if (ref.current) {
      const countUp = new CountUp(ref.current, end, {
        startVal: start,
        duration,
        suffix,
        prefix,
      });
      if (!countUp.error) {
        countUp.start();
      } else {
        console.error('CountUp error:', countUp.error);
      }
    }
  }, [end, start, duration, suffix, prefix]);

  return <span className={className} ref={ref}>{start}</span>;
};

export default CountUpWrapper;